import { extendTheme } from "@chakra-ui/react";
import MultiSelect from "../../../components/src/components/MultiSelect/theme";
import Alert from "./alert";
import { Button } from "./button";
import { default as Checkbox } from "./checkbox";
import { Input } from "./input";
import { default as KioskGlobalStyles } from "./kiosk/globalStyles.js";
import { default as kioskLayerStyles } from "./kiosk/layerStyles.js";
import { default as layerStyles } from "./layerStyles";
import { default as shadows } from "./shadows";
import { globalStyles } from "./styles";
import Table from "./table";

export default extendTheme(globalStyles, Button, Input, Table, {
  components: { Alert, Checkbox, MultiSelect },
  layerStyles: {
    ...layerStyles,
    ...kioskLayerStyles,
  },
  shadows,
  ...KioskGlobalStyles,
});
